import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    // redirect: '/basic/warehouse',
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  // {
  //   path: '/redirect',
  //   component: Layout,
  //   name: 'Redirect',
  //   children: [
  //     {
  //       path: '/redirect/:path(.*)',
  //       name: 'Redirect',
  //       component: () => import('@/views/Redirect/Redirect.vue'),
  //       meta: {}
  //     }
  //   ],
  //   meta: {
  //     hidden: true,
  //     noTagsView: true
  //   }
  // },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('login.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/403',
    component: () => import('@/views/Error/403.vue'),
    name: 'Forbidden',
    meta: {
      hidden: true,
      title: '403',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/landing-page',
  //   name: 'RootPage',
  //   meta: {
  //     title: t('router.basicInfo'),
  //     icon: 'bx:bxs-component',
  //     // alwaysShow: true
  //   },
  //   children: [
  //     {
  //       path: 'landing-page',
  //       component: () => import('@/views/landingPage/index.vue'),
  //       name: 'landingPage',
  //       meta: {
  //         title: t('portal.title'),
  //         noCache: true,
  //         affix: true,
  //         hideBreadcrumb:false
  //       }
  //     }
  //   ]
  // },
  {
    path: '/alarmsetting',
    component: Layout,
    redirect: '/alarmsetting/general',
    name: 'AlarmSetting',
    meta: {
      title: t('portal.menu.alarmSetting'),
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children: [
      {
        path: 'general',
        component: () => import('@/views/AlarmSetting/index.vue'),
        name: 'GeneralAlarmSetting',
        meta: {
          title: t('portal.menu.GeneralAlarmSetting'),
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
  {
    path: '/alarmmonitoring',
    component: Layout,
    redirect: '/alarmmonitoring/real',
    name: 'AlarmMonitoring',
    meta: {
      title: t('portal.menu.alarmMonitoring'),
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children: [
      {
        path: 'real',
        component: () => import('@/views/Alarm/index.vue'),
        name: 'RealAlarm',
        meta: {
          title: t('portal.menu.RealAlarm'),
          affix: true,
          hideBreadcrumb:false
        }
      },
      {
        path: 'history',
        component: () => import('@/views/Alarm/index.vue'),
        name: 'HistoryAlarm',
        meta: {
          title: t('portal.menu.HistoryAlarm'),
          affix: true,
          hideBreadcrumb:false
        }
      }
    ]
  },
  {
    path: '/alarmanalysis',
    component: Layout,
    redirect: '/alarmanalysis/statistics',
    name: 'Alarm',
    meta: {
      title: t('portal.menu.assetAnalysis'),
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children: [
      {
        path: 'statistics',
        component: () => import('@/views/FaultAnalysis/statistics.vue'),
        name: 'AlarmStatistics',
        meta: {
          title: t('portal.menu.alarmStatistics'),
          affix: true,
          hideBreadcrumb:false
        }
      },
      {
        path: 'analysis',
        component: () => import('@/views/FaultAnalysis/analysis.vue'),
        name: 'AlarmAnalysis',
        meta: {
          title: t('portal.menu.assetAnalysis'),
          affix: true,
          hideBreadcrumb:false
        }
      }
    ]
  },
  {
    path: '/syssetting',
    component: Layout,
    redirect: '/syssetting/messagepush',
    name: 'SysSetting',
    meta: {
      title: t('portal.menu.sysSettings'),
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children: [
      {
        path: 'messagepush',
        component: () => import('@/views/NotifySetting/messagepush.vue'),
        name: 'Messagepush',
        meta: {
          title: t('portal.menu.messagepush'),
          affix: true,
          hideBreadcrumb: true
        }
      },
      {
        path: 'alertsound',
        component: () => import('@/views/SysSetting/Alertsound.vue'),
        name: 'Alertsound',
        meta: {
          title: t('portal.menu.alertSoundSetting'),
          affix: true,
          hideBreadcrumb:false
        }
      },
    ]
  },
  {
    path: '/alarmlist',
    component: Layout,
    redirect: '/alarmlist/dropdown',
    name: 'AlarmList',
    meta: {
      title: t('alarm.alarmList'),
      icon: 'bx:bxs-component',
      // hidden: true,
      // alwaysShow: true
    },
    children: [
      {
        path: 'dropdown',
        component: () => import('@/views/components/DropDownContent.vue'),
        name: 'DropDownContent',
        meta: {
          title: t('alarm.alarmList'),
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      }
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
